import React from 'react'
import {PRACTICE_LABORATORY_DESCRIPTION} from '../../../constants/CyHomepage'
import {PracticeItemCard} from "../components/PracticeItemCard";

const PracticeLaboratoryPanel: React.FC<{
    isInScreen: boolean
}> = ({
          isInScreen = false
      }) => {

    function clickStat(category, page) {
        // 统计卡片点击流量
        if (window) {
            // 用 stat-portrait
            // @ts-ignore
            window.xqui.useStat({
                action: 'click',
                category: category,
                bizType: 5,
                page: page
            })
        }

    }

    return (
        <div className='practice-laboratory-panel-children'>
            <div className='description-cards'>
                {
                    PRACTICE_LABORATORY_DESCRIPTION.map((item, index) => (
                        <div className={`description-card ${isInScreen ? 'animated fadeInUp' : ''}`}
                             style={{ animationDuration: `${index > 1 ? `${1.5 + index * 0.3}s` : '1s'}` }}
                             onClick={() => clickStat(item.category, item.page)}>

                            <PracticeItemCard
                                key={index}
                                title={item.title}
                                imgUrl={item.imgUrl}
                                url={item.url}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default PracticeLaboratoryPanel
